const SIZE_MAP = [2, 4, 6];

export class CNLineAcross {
    constructor(data) {
        this.name = data.t;
        this.color = data.c;
        this.size = data.th;
        this.id = data.d[0];
        this.y = data.d[1];
        this.drawId = data.drawId;
        this.width = data.width;
        this.removerImage = data.removerImage;

        this.remover = this.buildRemover();
        this.hitbox = this.buildHitbox();
        this.dragger = this.buildDragger();
        this.element = this.buildElement();
    }

    setDragStart(callback) {
        this.element.on("dragstart", callback);
    }

    setDragEnd(callback) {
        this.element.on("dragend", callback);
    }

    buildRemover() {
        const remover = new Konva.Image({
            image: this.removerImage,
            width: 20,
            height: 20,
            name: "remover",
            x: this.width - 20,
            y: 20,
            visible: false,
        });
        remover.on("mouseover", () => {
            document.body.style.cursor = "pointer";
        });
        remover.on("mouseout", () => {
            document.body.style.cursor = "default";
        });

        return remover;
    }

    buildHitbox() {
        const dragger = new Konva.Rect({
            x: 0,
            y: -20,
            width: this.width,
            height: 40,
            // fill: "rgba(0,0,0,0.5)",
            // fill: "red",
            name: "hitbox",
        });

        return dragger;
    }

    buildDragger() {
        const dragger = new Konva.Rect({
            x: 0,
            y: -20,
            width: this.width,
            height: 40,
            // fill: "rgba(0,0,0,0.5)",
            // fill: "red",
            stroke: "#0e8ce9",
            // fill: "rgba(255,0,0,0.2)",
            strokeWidth: 0,
            dash: [10, 5],
            name: "dragger",
            visible: false,
        });

        return dragger;
    }

    setRemoverAction(callback) {
        this.remover.on("click", callback);
        this.remover.on("tap", callback);
    }

    setColor(color) {
        this.color = color;
        this.currentLine.stroke(color);
    }

    setClickAction(callback) {
        this.element.on("click", () => callback(this.color));
        this.element.on("tap", () => callback(this.color));
    }

    setDragClick(callback) {
        const _this = this;
        function click(e) {
            callback(e);
            _this.dragger.strokeWidth(2);
        }
        this.element.on("click", (e) => click(e));
        this.element.on("tap", (e) => click(e));
    }

    buildElement() {
        const group = new Konva.Group({
            x: 0,
            y: this.y,
            draggable: true,
            id: this.id,
            name: this.name,
            dragBoundFunc: function (pos) {
                return {
                    x: 0,
                    y: pos.y,
                };
            },
        });

        this.currentLine = new Konva.Line({
            points: [0, 0, this.width, 0],
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            name: "lineacross",
        });

        group.add(this.currentLine);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}
